import { render } from "./InterfaceMenu.vue?vue&type=template&id=071ecc31"
import script from "./InterfaceMenu.vue?vue&type=script&lang=js"
export * from "./InterfaceMenu.vue?vue&type=script&lang=js"

import "./InterfaceMenu.vue?vue&type=style&index=0&id=071ecc31&lang=scss"

import exportComponent from "/tmp/ee6909f6-e1a9-41e2-8541-cccc71f1c53b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__